import { render, staticRenderFns } from "./_qv-last-sale.vue?vue&type=template&id=6aca0120&scoped=true"
import script from "./_qv-last-sale.vue?vue&type=script&lang=js"
export * from "./_qv-last-sale.vue?vue&type=script&lang=js"
import style0 from "./_qv-last-sale.vue?vue&type=style&index=0&id=6aca0120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca0120",
  null
  
)

export default component.exports